import { render } from "./certificate-info.vue?vue&type=template&id=7fa10b62&scoped=true"
import script from "./certificate-info.vue?vue&type=script&lang=js"
export * from "./certificate-info.vue?vue&type=script&lang=js"

import "./certificate-info.vue?vue&type=style&index=0&id=7fa10b62&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fa10b62"]])

export default __exports__